import React, { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import api from "@/lib/api";
import { useProvince } from "@/contexts/ProvinceContext";

export default function WhatsAppButton() {
  const { selected } = useProvince();
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    api.get(`/hotline-button${selected ? `?province_id=${selected.id}` : ""}`).then((r) => setCfg(r.data)).catch(() => {});
  }, [selected?.id]);
  if (!cfg?.is_active || !cfg?.phone_number) return null;
  const num = cfg.phone_number.replace(/[^0-9]/g, "");
  const msg = encodeURIComponent(cfg.default_message || "Merhaba SİNE81 Haber Hattı");
  return (
    <a data-testid="whatsapp-sticky" href={`https://wa.me/${num}?text=${msg}`} target="_blank" rel="noreferrer" className="wa-sticky hover:scale-105 transition-transform" aria-label="WhatsApp Haber Hattı" style={{ background: cfg.color || "#25D366" }}>
      <MessageCircle className="w-6 h-6" />
    </a>
  );
}
